import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

import { useCurrentPractice } from 'contexts/PracticeContext'
import { selectUser } from 'selectors/auth'

import { MavenChatWidget } from './MavenChatWidget'

export const ChatWidget = () => {
	const currentUser = useSelector(selectUser)
	const { currentPracticeObject } = useCurrentPractice()

	const isLoading = useMemo(() => {
		return !currentUser || isEmpty(currentPracticeObject)
	}, [currentUser, currentPracticeObject])

	if (isLoading) {
		return null
	}

	return <MavenChatWidget />
}
